import { all, call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { setCallQueues } from '../../../state/callQueue/callQueueSlice';
export function* fetchCallQueueSaga() {
    try {
        const { uid, user, domain } = yield select(selectUserCredentials);

        // Fetch list of queues the user is part of
        const params = {
            agent: uid,
            user,
            domain,
            fromat: 'json',
        };
        const apiUrl = '?object=callqueue&action=read';
        const response = yield call(cirrusClient.get, apiUrl, { params: params });

        const queues = response.data;

        // exit if no queues
        if (!Array.isArray(queues) || queues.length === 0) {
            return;
        }

        // Fetch agent list and queue details for each queue
        const queueDetails = yield all(
            queues.map(function* (queue) {
                const params = {
                    object: 'agent',
                    action: 'read',
                    user,
                    domain,
                    queue_name: queue.queue_name,
                    format: 'json',
                };

                const response = yield call(cirrusClient.get, '', { params: params });
                const agentsDetail = response.data || [];

                return {
                    queueName: queue.queue_name,
                    description: queue.description,
                    agents: agentsDetail.map(agent => ({
                        user: agent.sub_user,
                        displayName: agent.sub_fullname,
                        uid: agent.sub_login,
                    })),
                };
            })
        );
        yield put(setCallQueues(queueDetails));

    } catch (error) {
        console.error('Error fetching call queues and agent details:', error);
    }
}
